import { useState } from 'react';

const faqs = [
  {
    q: '如何选择适合自己的黄油？',
    a: '如果您追求纯正浓郁的奶香，建议选择无盐动物黄油；如果您喜欢复杂的风味层次和发酵香气，发酵黄油是更好的选择。烘焙蛋糕饼干推荐无盐黄油，制作可颂酥皮推荐比利时高熔点黄油片。您也可以根据品牌信誉、产地、认证标准等综合考量。',
  },
  {
    q: '黄油应该如何保存？',
    a: '未开封的黄油可在冰箱冷藏保存至保质期。开封后的黄油建议用保鲜膜密封包裹，放入黄油保存盒中冷藏，2-4周内食用完毕。如需长期保存，可将黄油冷冻，-18℃以下可保存6-9个月。',
  },
  {
    q: '你们的黄油是正品吗？',
    a: '在线黄油平台所有产品均为品牌方授权或正规渠道进口，每一批产品都有完整的报关单和检验检疫证明。我们承诺假一赔十，让您买得放心。',
  },
  {
    q: '配送范围和时效是怎样的？',
    a: '我们目前支持全国30+城市配送，一线城市下单后24小时内送达，其他城市2-3天。所有黄油产品均采用专业冷链包装，确保产品新鲜品质。具体可查看配送说明或咨询客服。',
  },
  {
    q: '收到黄油如果有问题怎么办？',
    a: '如果您收到的产品有任何质量问题（如包装破损、变质等），请在签收后24小时内联系客服，我们提供无条件退换货服务。我们的客服团队会在2小时内响应您的诉求。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于黄油选购和使用的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <span className={`w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.q,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: faq.a,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}